import moment from 'moment';

export default Vue => {
  moment.locale('zh-cn');
  Vue.prototype.formatDate = function(value) {
    if (!value) {
      return '';
    }
    return moment(value).format('YYYY.MM.DD');
  };
  Vue.prototype.formatDateTime = function(value) {
    if (!value) {
      return '';
    }
    return moment(value).format('YYYY-MM-DD hh:mm');
  };
  //   Vue.prototype.relativeTime = function (value) {
  //     if (!value) {
  //       return '';
  //     }
  //     return moment(value).fromNow();
  //   };
};
